





























import { Component, Vue } from 'vue-property-decorator';
import Sidebar from '@/components/Sidebar.vue';
import { mapState } from 'vuex';
import Development from '@/components/Development.vue';

@Component({
    components: {
        Sidebar,
        Development,
    },
    computed: {
        ...mapState('auth', {
            currentUser: (state: any) => state.currentUser,
        }),
    },
})
export default class App extends Vue {
    public currentUser!: any;
    public isSmallScreen: boolean = false;
    data() {
        return {
            mode: 'darks',
        };
    }

    mounted() {
        this.checkScreenSize();
        window.addEventListener('resize', this.checkScreenSize);
    }

    checkScreenSize() {
        this.isSmallScreen = window.innerWidth < 768;
    }

    handleClickOutside(event: MouseEvent) {
        const sidebar = this.$refs.sidebar as Vue;
        if (sidebar && !sidebar.$el.contains(event.target as Node)) {
            sidebar.$data.showResponsiveDiv = false;
        }
    }
}
